<template>
    <uib-pagination
      v-model="pagination"
      :total-items="totalCountCP"
      :items-per-page="listSize"
      :max-size="$mq == 'mobile' ? 5 : 10"

      :boundary-links="true"
      first-text   ="<<" last-text=">>"
      previous-text="<"  next-text=">"
      @change="doChangePage"
    />
    <!-- <uib-pagination
      v-model="pagination"
      :total-items="totalPages"
      :max-size="totalVisible"

      :boundary-links="true"
      first-text   ="<<" last-text=">>"
      previous-text="<"  next-text=">"
    /> -->
</template>

<style>

/*-----------------------------------------------------------------------------------------------
	페이지
-------------------------------------------------------------------------------------------------*/
 .paging {text-align: center; }
ul.pagination { margin:20px auto; font-weight: bold; }
ul.pagination,
ul.pagination > li,
ul.pagination > li > a { display: inline-block;}
ul.pagination > li > a { border: 1px solid #ACA8A2;  padding: 8px; min-width: 18px; text-align: center;}

ul.pagination > li.active   a { color: #ffffff; background-color: #064680; border: 1px solid #064680; }
ul.pagination > li.disabled a { color: #D9D9D9; cursor: default; }
ul.pagination > li { margin-left:-1px;}
@media screen and (max-width:640px){
    ul.pagination > li > a { min-width:15px;}
}
</style>
<script>
const isDebug = false
export default {
  inheritAttrs: false,
  props : {
    totalVisible: { type: Number, default: 10 }, // 화면에 보여주는 최대 페이지 수

    listSize: { type: Number, default: 10 }, // 한 목록의 아이템수

    totalCount: { type: Number  }, // 전테 아이템 수
    length: { type: Number,}, // 한 목록의 아이템수

    // value: { type: Number, default: 1 }, // 현재 페이지 번호
    pageNo: { type: Number, }, // 현재 페이지 번호
    value: { type: Number, },
  },
  data() {
    return {
      pagination: { currentPage: 1 },
      vModelMode: this.value !== undefined,
      pno: this.value || this.pageNo,
      totalCountCP: 0,
    }
  },
  created() {
    if      (this.totalCount !== undefined) { this.totalCountCP = this.totalCount }
    else if (this.length     !== undefined) { this.totalCountCP = this.length * this.listSize }

    if      (this.value  !== undefined) { this.pagination.currentPage = this.value  }
    else if (this.pageNo !== undefined) { this.pagination.currentPage = this.pageNo }
  },
  watch: {
    totalCount() { this.totalCountCP = this.totalCount },
    length()     { this.totalCountCP = this.length * this.listSize },

    value()      { this.pagination.currentPage = this.value },
    pageNo()     { this.pagination.currentPage = this.pageNo },
  },
  methods: {
    doChangePage() {
      if (this.value !== undefined) {
        isDebug && console.log("EMIT INPUT");
        this.$emit("input",         this.pagination.currentPage)
      }
      else if (this.pageNo !== undefined) {
        isDebug && console.log("EMIT sync");
        this.$emit("update:pageNo", this.pagination.currentPage)
      }

      this.$emit("changePage",    this.pagination.currentPage)
    }
  },
  // computed: {
  //   minWidth() {
  //     const m = Math.min(this.length, this.totalVisible)
  //     // console.log("length = ", this.length, ", tot = ", this.totalVisible, "m = " + m);
  //     return ((m+2) * 44) + "px"
  //   }
  // },
}
</script>
